const ALLOWED_PROTOCOLS = ['https:', 'http:'];

export const InAppBrowserOpenerComponent = {
  transclude: true,
  templateUrl: 'components/in-app-browser-opener/in-app-browser-opener.html',
  controller: function InAppBrowserOpenerController(
    $element,
    $timeout,
    inAppBrowserService
  ) {
    'ngInject';

    this.$postLink = () => {
      $timeout(() => {
        $element.find('a').bind('click', this.onLinkClick);
      }, 0);
    };

    this.onLinkClick = (event) => {
      // If we apply both "link" and "bold" on element, `event` targets <strong> instead of <a>
      const element = this.resolveLinkElement(event);
      const isSupportedLink = (e) =>
        e.toElement && ALLOWED_PROTOCOLS.includes(element.protocol);
      const isSupportedEmbedLink = (e) =>
        element &&
        element.innerText &&
        ALLOWED_PROTOCOLS.some((protocol) =>
          element.innerText.includes(protocol)
        );

      if (event && (isSupportedLink(event) || isSupportedEmbedLink(event))) {
        inAppBrowserService.open(
          (event.currentTarget && event.currentTarget.href) || element.innerText
        );
      }
      event.preventDefault();
    };

    this.resolveLinkElement = (event) => {
      const element = ['STRONG', 'EM', 'U'].includes(event.toElement.tagName)
        ? event.toElement.parentElement
        : event.toElement;
      return element;
    };
  },
};
